import { Button } from '@user-portal/wikr-components';
import styled, { css } from 'styled-components';

import { color } from 'theme/selectors';

export const SurfaceMainButton = styled(Button)<typeof Button>`
    ${({ isLoading }) => css`
        p {
            color: inherit;
        }

        &:hover:not(:disabled) {
            background-color: ${color('on-primary')};
            color: #ffffff;
        }
        &:active:not(:disabled) {
            background-color: #171717;
            color: #ffffff;
            svg path {
                fill: #ffffff;
            }
        }
        &:disabled {
            cursor: not-allowed;
            color: #e0e0ea;
            background-color: #646464;
            svg path {
                fill: #e0e0ea;
            }
        }

        ${isLoading &&
        css`
            &:disabled {
                background-color: #171717;
                color: #ffffff;
                svg path {
                    fill: #ffffff;
                }
            }
        `}
    `}
`;

export const DefaultButton = styled(Button)<typeof Button>`
    border-radius: 0 !important;
`;
